import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Grid, Chip, Paper } from '@mui/material';
import { API_URL } from '../../config/api';
import { useAuth } from '../../context/AuthContext';

const CompletionStep = ({ completedSteps, onFinish }) => {
  const { user, getAuthHeaders } = useAuth();
  const [approvals, setApprovals] = useState(null);

  useEffect(() => {
    const loadApprovals = async () => {
      try {
        const res = await fetch(`${API_URL}/offboarding/exit-form/user/${user.id}`, { headers: getAuthHeaders() });
        const data = await res.json();
        if (res.ok && data.data && data.data.length > 0) {
          setApprovals(data.data[0].approvals || null);
        } else {
          setApprovals(null);
        }
      } catch (e) {
        setApprovals(null);
      }
    };
    if (user?.id) loadApprovals();
  }, [user, getAuthHeaders]);

  const statusChip = (ok) => (
    <Chip label={ok ? 'Approved' : 'Pending'} color={ok ? 'success' : 'warning'} size="small" />
  );

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Review your offboarding steps and approvals.
      </Typography>

      {approvals && (
        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>Exit Interview Approvals</Typography>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2">Reporting Manager: {statusChip(approvals?.rm?.status)}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2">IT: {statusChip(approvals?.it?.status)}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2">Admin: {statusChip(approvals?.admin?.status)}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2">Charge Owner: {statusChip(approvals?.charge?.status)}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2">HR: {statusChip(approvals?.hr?.status)}</Typography>
            </Grid>
          </Grid>
        </Paper>
      )}

      <ul>
        {completedSteps.map((step) => (
          <li key={step}>
            <Typography color="success.main">{step} ✓</Typography>
          </li>
        ))}
      </ul>
      <Typography color="info.main" sx={{ mt: 2 }}>
        Thank you for your contributions! We wish you the best in your future endeavors.
      </Typography>
      <Button variant="contained" sx={{ mt: 2 }} onClick={onFinish}>
        Finish & Exit
      </Button>
    </Box>
  );
};

export default CompletionStep;